export default __webpack_public_path__ + "static/media/doctor_1.9cb5240e.png";